import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import history from "./history";
import {Router} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import './i18n';

ReactDOM.render(
   <Router history={history}>
      <ScrollToTop/>
      <App/>
   </Router>
   , document.getElementById('root')
)